module.exports = __webpack_public_path__ + "static/media/specialMenu11012023.695860f0.pdf";